export const pciStyles = {
	header: {
		backgroundColor: '#d2d8e8',
	},
	sidebar: {
		backgroundColor: '#24292c',
		color: 'white',
	},
	button: {
		backgroundColor: '#f29a22',
		color: '#FFFFFF',
		border: '1px solid #f29a22',
		fontWeight: 600,
		':hover': {
			color: '#ffffff',
			backgroundColor: '#b6741a',
			borderColor: '#b6741a',
		},
	},
	text: {
		color: '#24292c',
		buttonLoadingColor: '#FFFFFF',
	},
	title: {
		color: 'black',
	},
	table: {
		headerBackgroundColor: '#24292c',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'PCI Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/pci/pci-logo.svg',
			height: 40,
			width: 40,
		},
		large: {
			src: '/pci/pci-logo-text.png',
			height: 45,
			width: 165,
		},
	},
	favicon: {
		src: '/pci/pci-logo.svg',
	},
	socials: {
		facebook: 'https://www.facebook.com/Parking-Concepts-Inc-133874870029211',
		linkedIn: 'https://www.linkedin.com/company/parking-concepts-inc./mycompany/?viewAsMember=true',
	},
	siteUrl: 'https://parkingconcepts.com/',
	orgName: 'Parking Concepts Inc',
};
